import { gql } from '@apollo/client';

export const FETCH_SERVICE_POINTS = gql`
  query FetchServicePoints(
    $service: ServicePointType
    $region: Region
    $atmTypes: [AtmType!]
    $branchServices: [BranchServices!]
  ) {
    servicePoints(
      first: 100
      service: $service
      region: $region
      atmTypes: $atmTypes
      branchServices: $branchServices
    ) {
      totalCount
      nodes {
        id
        name
        street
        postalCode
        city
        region
        latitude
        longitude

        atms {
          name
          type
          currencies
          openingHours {
            type
            text
          }
        }

        branches {
          name
          phoneNumber
          hasPostOffice
          id
          openingHours
          branchServices
          hasWheelchairAccess
          branchNumber
        }
      }
    }
  }
`;
